import React, { useEffect, useState, useContext } from "react";
import styles from "../css/SetupForm.module.css";
import Context from "../context/context";
import plusIcon from "../images/plus.svg";
import { openDB } from "idb";
import { v4 as uuidv4 } from "uuid";
import { Delete } from "@mui/icons-material";
import axios from "axios";
import { PencilAltIcon } from "@heroicons/react/solid";
import { CancelRounded } from '@mui/icons-material';
import SchemeForm from '../css/ReferenceScheme.module.css'

const PaymentModesForm = ({ onSave }) => {
  const [paymentMode, setPaymentMode] = useState({});
  const [outletId, setOutLetId] = useState({});
  const [newPaymentMode, setNewPaymentMode] = useState([]);
  const [updatedPaymentModem, setUpdatedPaymentMode] = useState([]);
  const context = useContext(Context);
  const [deletePopup, setDeletePopup] = useState(null);

  const { updateUnSync } = context;
  const getPamentModesData = async () => {
    let DBOpenReq = indexedDB.open(
      "FoodDo",
      +localStorage.getItem("IDBVersion") || 1
    );
    DBOpenReq.addEventListener("error", (err) => {
      console.warn(err);
    });
    DBOpenReq.addEventListener("success", (ev) => {
      let tx = ev.target.result.transaction("payment_modes", "readwrite");
      let store = tx.objectStore("payment_modes");
      let getReq = store.getAll();
      getReq.onsuccess = (outletReq) => {
        var outlet = outletReq.target.result;
        setPaymentMode(outlet);
      };
    });
  };
  useEffect(() => {
    getPamentModesData();
  }, []);

  useEffect(() => {
    const getData = () => {
      let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      DBOpenReq.addEventListener("error", err => console.warn(err));
      DBOpenReq.addEventListener("success", ev => {
        let tx = ev.target.result.transaction("outlet", "readwrite");
        let store = tx.objectStore("outlet");
        let getReq = store.getAll();
        getReq.onsuccess = (outletReq) => {
          var outlet = outletReq.target.result[0];
          if (outlet?.upi_setup) setUPISetup(outlet?.upi_setup)
          setOutLetId(outlet.outlet_uuid);
        };
      });
    };
    getData();
  }, []);

  const addPaymentMode = () => {
    let id = uuidv4();
    setNewPaymentMode([
      ...newPaymentMode,
      {
        ...paymentMode[0],
        IDENTIFIER: id,
        maintain_customer_balance: "N",
        outlet_wise_details: paymentMode[0].outlet_wise_details,
        payment_mode_name: "",
        payment_mode_otp: "",
        payment_mode_uuid: id,
      },
    ]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outletStore = db.transaction("outlet", "readwrite").objectStore("outlet");
    const outlet = await outletStore.get(localStorage.getItem('outlet_uuid'));
    await outletStore.put({ ...outlet, upi_setup: UPISetup })
    await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files").put({
      IDENTIFIER: 'upi_setup',
      RECON_TIME: Date.now(),
      upi_setup: UPISetup
    })
    updateUnSync()

    const store = db
      .transaction("payment_modes", "readwrite")
      .objectStore("payment_modes");
    updatedPaymentModem.forEach((item, i) => {
      const nData = {
        ...item,
      };
      const data = {
        ...nData,
        RECON_TIME: String(Date.now()),
        IDENTIFIER: `payment_mode:${item.payment_mode_uuid}`,
      };
      store.put(nData);
      handlePaymentModeUnsyncedFile(data);
    });

    newPaymentMode
      .filter((item) => item.payment_mode_name !== "")
      ?.forEach((item, i) => {
        const nData = {
          ...item,
        };
        const data = {
          ...nData,
          RECON_TIME: String(Date.now()),
          IDENTIFIER: `payment_mode-new:${item.payment_mode_uuid}`,
        };
        store.put(nData);
        handlePaymentModeUnsyncedFile(data);
      });
    onSave();
  };

  // Adding/Editing PaymentMode to unsynced_files collection in IndexedDB
  const handlePaymentModeUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("unsynced_files", "readwrite")
      .objectStore("unsynced_files");
    await tx.put(data);
    handlePaymentModeReconciliation(data);
    updateUnSync();
  };

  // Adding/Editing PaymentMode to reconciliation collection in IndexedDB
  const handlePaymentModeReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const paymentModeJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "payment_mode"
    );
    if (paymentModeJsonExists) {
      const paymentModes = paymentModeJsonExists?.details?.filter(
        (paymode) => paymode.payment_mode_uuid !== data.payment_mode_uuid
      );
      const editData = {
        ...paymentModeJsonExists,
        details: [
          ...paymentModes,
          {
            payment_mode_uuid: data.payment_mode_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "payment_mode",
        details: [
          {
            payment_mode_uuid: data.payment_mode_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };
  const DeleteSeat = async () => {
    const response = await axios({
      method: "delete",
      // url: "http://localhost:5001/payment/deletePaymentMode",
      url: "https://api.myfooddo.com/payment/deletePaymentMode",
      data: { payment_mode_uuid: deletePopup.payment_mode_uuid },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("activity", response);
    if (response.data.success) {
      const db = await openDB(
        "FoodDo",
        +localStorage?.getItem("IDBVersion") || 1
      );
      const indSeats = await db
        ?.transaction("payment_modes", "readwrite")
        ?.objectStore("payment_modes");
      await indSeats.delete(deletePopup.payment_mode_uuid);
      setDeletePopup(response.data.result);
    } else {
      setDeletePopup(response.data.result);
    }
  };

  const [UPISetup, setUPISetup] = useState({ status: 1 });
  const [UPIEditPOPUPStatus, setUPIEditPOPUPStatus] = useState(false)

  return (
    <>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.heading}>
          <h1>Payment Modes Setup</h1>
        </div>
        <div className={styles.formContainer}>
          <div
            className={styles.formGroup}
          // style={{ height: "350px", overflowY: "scroll" }}
          >
            <h2>Payment Setup</h2>

            <div className={styles.row}>
              <label className={styles.selectLabel}>
                Payment Name
                <input
                  type="text"
                  name="payment_mode_name"
                  className={styles.numberInput}
                  style={{ width: "12rem" }}
                  value={"UPI"}
                  onChange={() => { }}
                  disabled
                />
              </label>
              <lable>
                Status
                <div>
                  <input
                    type="checkbox"
                    checked={UPISetup?.status}
                    onChange={(e) => setUPISetup(doc => ({ ...doc, status: +e.target.checked }))}
                  />
                  <span></span>
                </div>
              </lable>
              <label onClick={() => setUPIEditPOPUPStatus(true)}>Edit<div><PencilAltIcon width={16} /></div></label>
            </div>

            {paymentMode?.length &&
              paymentMode?.map((payment, index) => (
                <div className={styles.row} key={index}>
                  <label className={styles.selectLabel}>
                    Payment Name
                    <input
                      type="text"
                      name="payment_mode_name"
                      className={styles.numberInput}
                      style={{ width: "12rem" }}
                      value={payment?.payment_mode_name}
                      onChange={(e) => {
                        setPaymentMode([
                          ...paymentMode.map((item, i) => {
                            if (item._id === payment._id) {
                              return {
                                ...item,
                                payment_mode_name: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        if (
                          updatedPaymentModem?.filter(
                            (item) => item._id === payment._id
                          ).length === 0
                        ) {
                          setUpdatedPaymentMode([
                            ...updatedPaymentModem,
                            ...paymentMode
                              .filter(
                                (itemfilter, i) =>
                                  itemfilter._id === payment._id
                              )
                              .map((item, i) => {
                                if (item._id === payment._id) {
                                  return {
                                    ...item,

                                    payment_mode_name: e.target.value,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                          ]);
                        } else {
                          setUpdatedPaymentMode([
                            ...updatedPaymentModem.map((item, i) => {
                              if (item._id === payment._id) {
                                return {
                                  ...item,
                                  payment_mode_name: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }
                      }}
                    />
                  </label>
                  <label
                    className={styles.selectLabel}
                    style={{ width: "5rem" }}
                  >
                    MCB
                    <select
                      type="text"
                      name="maintain_customer_balance"
                      className={styles.numberInput}
                      style={{ width: "5rem" }}
                      value={payment?.maintain_customer_balance}
                      disabled
                    >
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </label>
                  {payment.maintain_customer_balance === "Y" ? (
                    <lable>
                      OTP
                      <div>
                        <input
                          type="checkbox"
                          checked={
                            +payment?.outlet_wise_details?.filter(
                              (item) => item.outlet_uuid === outletId
                            )[0]?.payment_mode_otp === 1
                          }
                          onChange={(e) => {
                            setPaymentMode([
                              ...paymentMode.map((item) =>
                                item.payment_mode_uuid ===
                                  payment.payment_mode_uuid
                                  ? {
                                    ...item,

                                    outlet_wise_details:
                                      item?.outlet_wise_details?.map((id) =>
                                        id.outlet_uuid === outletId
                                          ? {
                                            ...id,
                                            payment_mode_otp: e.target
                                              .checked
                                              ? "1"
                                              : "0",
                                          }
                                          : id
                                      ),
                                  }
                                  : item
                              ),
                            ]);
                            if (
                              updatedPaymentModem?.filter(
                                (item) => item._id === payment._id
                              ).length === 0
                            ) {
                              setUpdatedPaymentMode([
                                ...updatedPaymentModem,
                                ...paymentMode
                                  .filter(
                                    (itemfilter, i) =>
                                      itemfilter._id === payment._id
                                  )
                                  .map((item) =>
                                    item.payment_mode_uuid ===
                                      payment.payment_mode_uuid
                                      ? {
                                        ...item,

                                        outlet_wise_details:
                                          item?.outlet_wise_details?.map(
                                            (id) =>
                                              id.outlet_uuid === outletId
                                                ? {
                                                  ...id,
                                                  payment_mode_otp: e.target
                                                    .checked
                                                    ? "1"
                                                    : "0",
                                                }
                                                : id
                                          ),
                                      }
                                      : item
                                  ),
                              ]);
                            } else {
                              setUpdatedPaymentMode([
                                ...updatedPaymentModem.map((item) =>
                                  item.payment_mode_uuid ===
                                    payment.payment_mode_uuid
                                    ? {
                                      ...item,
                                      outlet_wise_details:
                                        item?.outlet_wise_details?.map((id) =>
                                          id.outlet_uuid === outletId
                                            ? {
                                              ...id,
                                              payment_mode_otp: e.target
                                                .checked
                                                ? "1"
                                                : "0",
                                            }
                                            : id
                                        ),
                                    }
                                    : item
                                ),
                              ]);
                            }
                          }}
                        />
                        <span></span>
                      </div>
                    </lable>
                  ) : (
                    <div style={{ width: "28px" }} />
                  )}
                  <lable>
                    Status
                    <div>
                      <input
                        type="checkbox"
                        checked={
                          +payment?.outlet_wise_details?.filter(
                            (item) => item.outlet_uuid === outletId
                          )[0]?.status === 1
                        }
                        onChange={(e) => {
                          setPaymentMode([
                            ...paymentMode.map((item) =>
                              item.payment_mode_uuid ===
                                payment.payment_mode_uuid
                                ? {
                                  ...item,

                                  outlet_wise_details:
                                    item?.outlet_wise_details?.map((id) =>
                                      id.outlet_uuid === outletId
                                        ? {
                                          ...id,
                                          status: e.target.checked
                                            ? "1"
                                            : "0",
                                        }
                                        : id
                                    ),
                                }
                                : item
                            ),
                          ]);
                          if (
                            updatedPaymentModem?.filter(
                              (item) => item._id === payment._id
                            ).length === 0
                          ) {
                            setUpdatedPaymentMode([
                              ...updatedPaymentModem,
                              ...paymentMode
                                .filter(
                                  (itemfilter, i) =>
                                    itemfilter._id === payment._id
                                )
                                .map((item) =>
                                  item.payment_mode_uuid ===
                                    payment.payment_mode_uuid
                                    ? {
                                      ...item,

                                      outlet_wise_details:
                                        item?.outlet_wise_details?.map((id) =>
                                          id.outlet_uuid === outletId
                                            ? {
                                              ...id,
                                              status: e.target.checked
                                                ? "1"
                                                : "0",
                                            }
                                            : id
                                        ),
                                    }
                                    : item
                                ),
                            ]);
                          } else {
                            setUpdatedPaymentMode([
                              ...updatedPaymentModem.map((item) =>
                                item.payment_mode_uuid ===
                                  payment.payment_mode_uuid
                                  ? {
                                    ...item,
                                    outlet_wise_details:
                                      item?.outlet_wise_details?.map((id) =>
                                        id.outlet_uuid === outletId
                                          ? {
                                            ...id,
                                            status: e.target.checked
                                              ? "1"
                                              : "0",
                                          }
                                          : id
                                      ),
                                  }
                                  : item
                              ),
                            ]);
                          }
                        }}
                      />
                      <span></span>
                    </div>
                  </lable>
                  <lable>
                    <div
                      style={{
                        color: "red",

                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeletePopup(payment);
                      }}
                    >
                      <Delete style={{ fontSize: "20px" }} />
                    </div>
                  </lable>
                </div>
              ))}
            {newPaymentMode?.length ? (
              newPaymentMode?.map((payment, index) => (
                <div className={styles.row} key={index}>
                  <label className={styles.selectLabel}>
                    Payment Name
                    <input
                      type="text"
                      name="payment_mode_name"
                      className={styles.numberInput}
                      style={{ width: "12rem" }}
                      value={payment?.payment_mode_name}
                      onChange={(e) =>
                        setNewPaymentMode([
                          ...newPaymentMode.map((item, i) => {
                            if (
                              item.payment_mode_uuid ===
                              payment.payment_mode_uuid
                            ) {
                              return {
                                ...item,
                                payment_mode_name: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ])
                      }
                    />
                  </label>
                  <label className={styles.selectLabel}>
                    Maintain Customer Balance
                    <select
                      type="text"
                      name="maintain_customer_balance"
                      className={styles.numberInput}
                      style={{ width: "12rem" }}
                      value={payment?.maintain_customer_balance}
                      onChange={(e) =>
                        setNewPaymentMode([
                          ...newPaymentMode.map((item, i) => {
                            console.log(payment);
                            if (
                              item.payment_mode_uuid ===
                              payment.payment_mode_uuid
                            ) {
                              return {
                                ...item,
                                maintain_customer_balance: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ])
                      }
                    >
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </label>
                  <label>
                    Status
                    <div>
                      <input
                        type="checkbox"
                        checked={
                          +payment?.outlet_wise_details?.filter(
                            (item) => item.outlet_uuid === outletId
                          )[0]?.status === 1
                        }
                        onChange={(e) => {
                          setNewPaymentMode([
                            ...newPaymentMode.map((item) =>
                              item.payment_mode_uuid ===
                                payment.payment_mode_uuid
                                ? {
                                  ...item,
                                  outlet_wise_details:
                                    item?.outlet_wise_details?.map((id) =>
                                      id.outlet_uuid === outletId
                                        ? {
                                          ...id,
                                          status: e.target.checked
                                            ? "1"
                                            : "0",
                                        }
                                        : id
                                    ),
                                }
                                : item
                            ),
                          ]);
                        }}
                      />
                      <span></span>
                    </div>
                  </label>
                </div>
              ))
            ) : (<div />)}
            <button
              className={styles.addMealButton}
              onClick={addPaymentMode}
              type="button"
            >
              <img src={plusIcon} alt="plus" />
            </button>
          </div>
          <button type="submit" className={styles.submit}>Save changes</button>
        </div>
      </form>
      {deletePopup && (
        <div className="newCategory">
          <div className="newCatContainer">
            <div className="newCatContainer_header">
              {console.log(deletePopup)}
              <h2>
                {deletePopup?.payment_mode_name
                  ? `Delete Payment Mode ${deletePopup.payment_mode_name} ?`
                  : deletePopup}
              </h2>
              {/* <XIcon className='closeicon' onClick={close} /> */}
            </div>
            <div
              className="newCatContainer2"
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button
                onClick={() => {
                  setDeletePopup(null);
                  getPamentModesData();
                }}
              >
                {deletePopup?.payment_mode_name ? "Cancel" : "Okay"}
              </button>
              {deletePopup?.payment_mode_name ? (
                <button onClick={() => DeleteSeat()}>Confirm</button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
      {UPIEditPOPUPStatus && <UPIEditPOPUP
        close={() => setUPIEditPOPUPStatus(false)}
        updateText={text => setUPISetup(doc => ({ ...doc, alert_text: text }))}
        alertText={UPISetup?.alert_text}
      />}
    </>
  );
};

export const defaultPaymentAlert = `Rupees {AMOUNT} received. Thanks for your visit at ${localStorage.getItem('outlet-name')}.`
const UPIEditPOPUP = ({ close, updateText, alertText }) => {

  const [text, setText] = useState(alertText || defaultPaymentAlert)
  const submitHandler = e => {
    e.preventDefault();
    close();
    updateText(text);
  };

  return (
    <div className={SchemeForm.popupContainer}>
      <div className={SchemeForm.scheme_form_popup_container} style={{ boxShadow: '0 0 10px 4px grey' }}>
        <div className={SchemeForm.formHead}>
          <h2>UPI Setup</h2>
          <CancelRounded onClick={close} className={SchemeForm.close} />
        </div>
        <div className={SchemeForm.scheme_form_container}>
          <form className={SchemeForm.scheme_form} onSubmit={submitHandler}>
            <div className={`${styles.formGroup} ${SchemeForm.messagePopupContainer}`}>
              <h2>Alert Text</h2>
              <div className={styles.row}>
                <label className={styles.selectLabel}>
                  <textarea
                    className={styles.messageTextarea}
                    value={text}
                    onChange={e => (e.target.value.includes('{AMOUNT}') && e.target.value.split('\n').length < 6) && setText(e.target.value)}
                    maxLength={250}
                  />
                </label>
              </div>
            </div>
            <button type='submit' className={SchemeForm.saveBtn}>Save</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PaymentModesForm;